import { getFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-18140 Добавить проверку текущего значения полной квоты для отображения
export const tempHideOverquotaBanner: boolean | undefined = getFeature('temp-hide-overquota-banner');
